"use client";

import { useState } from "react";
import DealHeroFilm from "./DealHeroFilm";
import PhotoCreditMini from "./PhotoCreditMini";
import { useSiteContext } from "@/components/providers/SiteContextProvider";
import { getTranslations } from "@/lib/i18n";
import {
  DEALFILMKOP_HOOGTE_KLASSE,
  KOPBALK_MARGE_KLASSE,
  KOPBALK_TOP_KLASSE,
} from "@/lib/filmkop-maten";

// De server geeft de bestaande LCP-foto als children door. Alleen de film en
// zijn pauzeknop komen later; zonder film blijven positie en hoogte identiek.
export default function DealFilmKop({ children, dealsId = null, fotosHref = null, credit = "" }) {
  const [stopSlot, setStopSlot] = useState(null);
  const { locale } = useSiteContext();
  const { t } = getTranslations(locale);

  return (
    <div
      data-testid="deal-film-kop"
      // Oude fotohoogte + kopbalkruimte - de vroegere kaartoverlap (32px).
      // Daardoor blijven titel, prijs en boekknop op dezelfde hoogte, terwijl
      // de kruimelregel nu onder de film past zonder onder de kaart te vallen.
      className={`relative w-full ${KOPBALK_MARGE_KLASSE} ${DEALFILMKOP_HOOGTE_KLASSE} overflow-hidden bg-[#1f2a37]`}
    >
      {children}
      {dealsId != null && <DealHeroFilm dealsId={dealsId} stopSlot={stopSlot} />}
      <PhotoCreditMini credit={credit} />
      {/* De donkere bovenband komt, net als bij CategoryFilmKop, uit Navbar. */}
      <div
        ref={setStopSlot}
        data-testid="deal-film-stop-slot"
        className={`pointer-events-none absolute z-20 right-0 ${KOPBALK_TOP_KLASSE} w-20 h-16`}
      />
      {fotosHref && (
        <a
          href={fotosHref}
          className="absolute z-20 bottom-3 left-4 rounded-full bg-white/95 px-4 py-2 text-sm font-semibold text-[#233944] shadow-sm hover:bg-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0a8de9]"
        >
          {t("booking.rooms.view_photos")}
        </a>
      )}
    </div>
  );
}
